import styled from 'styled-components';

import { 
  PADDING_CONTENT_PAGE, PADDING_PAGE, 
  BACKGROUND_DELETE_RESERVATION_INFO_SUCCESS, COLOR_DELETE_RESERVATION_ICON_SUCCESS, 
  BACKGROUND_DELETE_RESERVATION_INFO_ERROR, COLOR_DELETE_RESERVATION_ICON_ERROR, 
  BACKGROUND_DELETE_RESERVATION_INFO_WARNING, COLOR_DELETE_RESERVATION_ICON_WARNING, 
  FONT_SIZE_DELETE_RESERVATION_ICON, COLOR_EMAIL_CONFIRM_ICON_WARNING,
} from '../../../globals';


export const StyledDeleteReservationContent = styled.div`
  padding: ${PADDING_PAGE}px;
  margin-top: 15px;

  .delete-reservation-laoder {
    position: relative;
    min-height: 100px;
  }

  .delete-reservation-table-success {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_DELETE_RESERVATION_INFO_SUCCESS};
  }

  .delete-reservation-icon-success {
    font-size: ${FONT_SIZE_DELETE_RESERVATION_ICON}em;
    color: ${COLOR_DELETE_RESERVATION_ICON_SUCCESS};
    padding: 10px;
  }

  .delete-reservation-table-error {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_DELETE_RESERVATION_INFO_ERROR};
  }

  .delete-reservation-icon-error {
    font-size: ${FONT_SIZE_DELETE_RESERVATION_ICON}em;
    color: ${COLOR_DELETE_RESERVATION_ICON_ERROR};
    padding: 10px;
  }

  .delete-reservation-table-warning {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_DELETE_RESERVATION_INFO_WARNING};
  }

  .delete-reservation-icon-warning {
    font-size: ${FONT_SIZE_DELETE_RESERVATION_ICON}em;
    color: ${COLOR_DELETE_RESERVATION_ICON_WARNING};
    padding: 10px;
  }

  .delete-reservation-text {
    width: 100%;
  }

  .delete-reservation-btn {
    margin-left: 6px;
    background: ${COLOR_EMAIL_CONFIRM_ICON_WARNING};
    color: white;
    border: none;
    padding: 0.5rem 0.75rem;
    font-weight: bold;
  }

  .delete-reservation-btn:hover {
    background: #e66801;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DeleteReservationContent/styles/StyledDeleteReservationContent.js